<template>
    <div
        v-if="!!message && !!message.message"
        :class="{ [`toast-${message.type}`]: true }"
        class="toast system-message"
        @click="$emit('click')"
    >
        <button
            type="button"
            :label="$root.translate('Dismiss')"
            class="btn btn-clear"
        >
        </button>
        <div>
            <div>{{ message.message }}</div>
        </div>
        <!--
        <progress
            v-if="!!countdown"
            :value="countdown"
            :max="message.dismiss_after"
            class="progress"
        ></progress>
        //-->
    </div>
</template>

<script>
export default {
    props: {
        message: {
            type: Object,
            required: true
        },
        countdown: {
            validator: prop => !prop || (typeof prop === "number")
        }
    }
}
</script>
